import { ApiError, InternalError, RequestError } from "redux-api-middleware";

export type ReduxApiMiddlewareErrorType = InternalError | RequestError | ApiError<[]>;

export interface Part {
  id: string;
  price: number;
  priceInt: string;
  code: string;
  ruDescription: string;
  enDescription: string;
}

export interface Parts extends ReadonlyArray<Part> {}

export interface State {
  parts?: Parts;
  query?: string;
  links?: Links;
  meta?: Meta;
  loading: boolean;
  error?: ReduxApiMiddlewareErrorType;
}

interface Links {
  first?: string;
  last?: string;
  next?: string;
  prev?: string;
}

interface Attributes {
  "ru-description": string;
  "en-description": string;
  "price-int": string;
  price: number;
  code: string;
}

interface DataItem {
  type: string;
  id: string;
  attributes: Attributes;
}

interface Data extends ReadonlyArray<DataItem> {}

interface Meta {
  pagination: {
    page: number;
    pages: number;
    count: number;
  };
}

interface SuccessResponce {
  links: Links;
  data: Data;
  meta: Meta;
}

export const PARTS_REQUEST = "PARTS_REQUEST";
export const PARTS_SUCCESS = "PARTS_SUCCESS";
export const PARTS_FAILURE = "PARTS_FAILURE";

interface RequestPartsAction {
  type: typeof PARTS_REQUEST;
}

interface SuccessPartsAction {
  type: typeof PARTS_SUCCESS;
  payload: SuccessResponce;
}

interface FailurePartsAction {
  type: typeof PARTS_FAILURE;
  payload: ReduxApiMiddlewareErrorType;
}

export const PARTS_SAVE_QUERY = "PARTS_SAVE_QUERY";
interface SaveQueryAction {
  type: typeof PARTS_SAVE_QUERY;
  payload: string;
}

export type PartsActionTypes = SaveQueryAction | RequestPartsAction | SuccessPartsAction | FailurePartsAction;
